<div
  class="login-container flex flex-column justify-content-center align-items-center h-screen bg-gray-50"
>
  <div
    class="login-box bg-white p-5 shadow-2 border-round-xl border-1 border-300 w-full max-w-28rem"
  >
    <h4 class="text-xl font-bold text-center mt-0 mb-4">PalEasy Login</h4>

    <div class="flex flex-column gap-3">
      <p class="text-center text-600">
        Accedi con il tuo account al Portale
      </p>
      
      <p-button
        label="Login con Microsoft"
        icon="pi pi-microsoft"
        (onClick)="azureLogin()"
        [loading]="isLoading()"
        styleClass="w-full p-button-lg"
        severity="info"
      >
      </p-button>
      
      <small class="text-center text-500 mt-2">
        <i class="pi pi-shield mr-1"></i>
        Autenticazione sicura tramite Azure Active Directory
      </small>
      
      <!-- Dev Login Link (Development Only) -->
      @if (showMockLink) {
        <p-divider></p-divider>
        <p-button
          label="🔧 Dev Login (auth-test)"
          (onClick)="goToAuthTest()"
          styleClass="w-full"
          severity="secondary"
          [outlined]="true"
        >
        </p-button>
      }
    </div>
